// extracted by mini-css-extract-plugin
export var mainGrid = "grid-module--main-grid--04lMB";